import { useEffect, useRef } from 'react';

export const useScrollFade = (distance = 82) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let frame = 0;
    const update = () => {
      frame = 0;
      const p = Math.min(Math.max(window.scrollY, 0) / distance, 1);
      const fade = 1 - p;
      el.style.setProperty('--fade', String(fade));
      el.style.setProperty('--shift', `${-p * 24}px`);
      el.style.setProperty('--fade-events', fade < 0.05 ? 'none' : 'auto');
      el.setAttribute('aria-hidden', fade < 0.05 ? 'true' : 'false');
    };
    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [distance]);

  return ref;
};
